export const common = {
  app: {
    title: "Belora",
    tagline: "Gestión de mantenimiento geolocalizada",
  },
  nav: {
    ariaLabel: "Navegación principal",
    skipToContent: "Saltar al contenido principal",
    toggleMenu: "Alternar menú",
    home: "Inicio",
    tech: "Técnico",
    profile: "Perfil",
    admin: "Admin",
    settings: "Ajustes",
    langSwitch: "Selector de idioma",
    language: "Idioma",
    langEn: "English",
    langEs: "Español",
    workflowManagement: "Gestión de Flujos",
    fsmConfiguration: "Configuración FSM",
    workflows: "Flujos",
    states: "Estados",
    transitions: "Transiciones",
    entityTypes: "Tipos de Entidad",
    documentTypes: "Tipos de Documento",
    entities: "Entidades",
    roles: "Roles",
    welcome: "Inicio",
    administration: "Administración",
    users: "Usuarios",
    customers: "Clientes",
    locations: "Ubicaciones",
    stations: "Estaciones",
    devices: "Candados",
    map: "Mapa",
    bikes: "Bicis",
    materials: "Materiales",
    bikeModels: "Modelos de Bicicleta",
    customerSwitcher: "Selector de Cliente",
    requests: "Solicitudes",
    notificationChannels: "Canales de Notificación",
    kpis: "KPIs Operaciones",
    budget: "Presupuesto Materiales",
    tracking: "Seguimiento",
    toggleColorScheme: "Cambiar tema de color",
    palette: "Tema",
    paletteBelora: "Belora",
    paletteDefault: "Default",
  },
  common: {
    loading: "Cargando...",
    error: "Error",
    required: "Obligatorio",
    invalidFormat: "Formato inválido",
    loadError: "No se pudieron cargar las opciones. Actualiza para reintentar.",
    actions: "Acciones",
    save: "Guardar",
    cancel: "Cancelar",
    clear: "Limpiar",
    create: "Crear",
    edit: "Editar",
    update: "Actualizar",
    delete: "Eliminar",
    deactivate: "Desactivar",
    reactivate: "Reactivar",
    deactivateConfirm: "¿Desactivar este registro? Esta acción es reversible.",
    deactivated: "Desactivado",
    manage: "Gestionar",
    view: "Ver",
    back: "Volver",
    print: "Imprimir",
    name: "Nombre",
    description: "Descripción",
    customer: "Cliente",
    noCustomers: "Sin Clientes",
    type: "Tipo",
    initial: "Inicial",
    final: "Final",
    pickOne: "Selecciona uno",
    noItems: "No se encontraron elementos.",
    success: "Éxito",
    import: "Importar",
    export: "Exportar",
    deleteConfirm: "¿Está seguro de que desea eliminar <b>{{name}}</b>?",

    undoneWarning: "Esta acción no se puede deshacer.",
    notFound: "No encontrado",
    imageViewer: "Visor de imágenes",
    copy: "Copiar al portapapeles",
    fieldRequired: "{{field}} es obligatorio",
    previousImage: "Imagen anterior",
    nextImage: "Imagen siguiente",
    status: "Estado",
    statusCritical: "crítico",
    statusWarning: "advertencia",
    yes: "Sí",
    no: "No",
    all: "Todos",
    hide: "Ocultar",
    show: "Mostrar",
    copied: "Copiado",
    confirm: "Confirmar",
    unexpectedError: "Ocurrió un error inesperado.",
    unknownError: "Ocurrió un error inesperado. Por favor, inténtalo de nuevo.",
    uploadError: "Error al subir el archivo. Por favor, inténtalo de nuevo.",
    uploadErrorFile:
      'Error al subir "{{file}}". Por favor, inténtalo de nuevo.',
    deletedSuccessfully: "Eliminado con éxito",
    selectCustomer: "Selecciona un cliente",
    noResults: "Sin resultados",
    search: "Buscar...",
    uploadFiles: "Subir archivos",
    filesUploaded: "{{count}} archivo(s) subido(s)",
    addUrl: "Agregar URL",
    removeUrl: "Eliminar URL #{{index}}",
    invalidUrl: "Debe ser una URL válida (http:// o https://)",
    finalState: "final",
    readOnly: "Solo lectura",
    systemRole: "Sistema",
  },
  sync: {
    online: "En línea",
    offline: "Desconectado",
    syncing: "Sincronizando",
  },
  tasks: {
    empty: "Sin tareas asignadas",
    checklist: "Lista de verificación",
    notes: "Notas",
  },
  auth: {
    signOut: "Cerrar sesión",
    signOutAriaLabel: "Cerrar sesión de {{name}}",
    signIn: "Iniciar sesión",
    register: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar Contraseña",
    name: "Nombre",
    namePlaceholder: "Tu nombre",
    passwordPlaceholder: "Tu contraseña",
    confirmPasswordPlaceholder: "Confirma tu contraseña",
    emailPlaceholder: "tu@ejemplo.com",
    passwordMinLengthPlaceholder: "Al menos 6 caracteres",
    noAccount: "¿No tienes una cuenta?",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    createAccount: "Crear una cuenta",
    magicLink: "Enlace Mágico",
    passwordAuth: "Contraseña",
    completeRegistrationTitle: "Completa tu registro",
    completeRegistrationSubtitle:
      "Por favor establece tu contraseña y opcionalmente tu teléfono para terminar de configurar tu cuenta.",
    completeRegistrationSubmit: "Completar Registro",
    completeRegistrationSuccess: "Registro completado con éxito.",
    completeRegistrationError: "Error al completar el registro",
    phone: "Teléfono",
    phonePlaceholder: "+123456789 (Opcional)",
    registrationRestricted:
      "El registro está restringido a administradores. Si has sido invitado, por favor sigue el enlace que se te envió.",
    inviteUser: "Invitar Nuevo Usuario",
    sendInvitation: "Enviar Invitación",
    invitationCreated:
      "¡Invitación creada! Copia el enlace de abajo y envíaselo al usuario.",
    invalidEmail: "Correo electrónico no válido",
    nameRequired: "El nombre es obligatorio",
    passwordTooShort: "La contraseña debe tener al menos 8 caracteres",
    passwordNeedsUppercase:
      "La contraseña debe contener al menos una letra mayúscula",
    passwordNeedsNumber: "La contraseña debe contener al menos un número",
    profileUpdated: "Perfil actualizado correctamente",
    updateFailed: "Error al actualizar el perfil",
    noChanges: "No hay cambios que guardar",
    preferredLanguage: "Idioma preferido",
    preferredLanguageEn: "English",
    preferredLanguageEs: "Español",
    notificationChannels: "Canales de Notificación",
    notificationChannelsDesc:
      "Configura los canales de notificación externos para este customer.",
    channelCustomer: "Cliente",
    channelCustomerRequired:
      "Selecciona el customer al que pertenece este canal",
    channelLabel: "Etiqueta",
    channelType: "Tipo",
    channelRef: "Referencia del Canal",
    channelRefHint:
      'Se convierte a mayúsculas y los guiones pasan a guiones bajos. Ej. "belora-admin" → DISCORD_WEBHOOK_BELORA_ADMIN o EMAIL_BELORA_ADMIN_FROM.',
    channelEventTypes: "Tipos de Evento",
    channelActive: "Activo",
    channelInactive: "Inactivo",
    channelLanguage: "Idioma",
    channelCreate: "Agregar Canal",
    channelEdit: "Editar Canal",
    channelDeactivate: "Desactivar",
    channelReactivate: "Reactivar",
    channelNotifyRoles: "Roles a notificar",
    channelNotifyRolesHint:
      "Solo enviar este canal cuando un destinatario tenga uno de estos roles. Dejar vacío para enviar siempre.",
    channelSaveSuccess: "Canal guardado correctamente",
    channelSaveError: "Error al guardar el canal",
    channelDeactivateSuccess: "Canal desactivado",
    channelReactivateSuccess: "Canal reactivado",
    channelEmpty: "No hay canales configurados para este customer.",
    channelEnvStatus: "Entorno",
    channelEnvConfigured: "Configurado",
    channelEnvNotConfigured: "Sin configurar",
    channelEnvVerify: "Hacer click para verificar var de entorno",
    channelTestSend: "Enviar prueba",
    channelTestSuccess: "Prueba enviada",
    channelTestFailed: "Prueba fallida",
    channelTestEmailLabel: "Email destinatario",
    channelTestEmailTitle: "Enviar email de prueba",
    channelTestEmailConfirm: "Enviar",
    currentPassword: "Contraseña actual",
    currentPasswordPlaceholder: "Introduce tu contraseña actual",
    currentPasswordRequired: "La contraseña actual es obligatoria",
    newPassword: "Nueva contraseña",
    newPasswordPlaceholder: "Introduce tu nueva contraseña",
    security: "Seguridad",
    changePassword: "Cambiar contraseña",
    passwordChanged: "Contraseña cambiada correctamente",
    passwordChangeFailed: "Error al cambiar la contraseña",
    loginFailed: "Error al iniciar sesión",
    settingsDescription:
      "Gestiona la configuración de tu cuenta y preferencias de seguridad",
  },
  routes: {
    tech: "Técnico",
    techTasks: "Tareas",
    techMap: "Mapa",
    admin: "Admin",
    adminDashboard: "Panel",
    adminMap: "Mapa de flota",
    adminWorkOrders: "Órdenes de trabajo",
    adminInventory: "Inventario",
    settings: "Ajustes",
  },
  welcome: {
    title: "¡Bienvenido de nuevo, {{name}}!",
    subtitle: "Aquí tienes un resumen de tu cuenta y permisos.",
    personalInfo: "Información Personal",
    personalInfoSubtitle: "Detalles básicos de la cuenta",
    customerAccess: "Acceso de Cliente",
    customerAccessSubtitle: "Organizaciones a las que perteneces",
    noCustomer: "Sin cliente asignado (Solo registrado)",
    rolesAndEntities: "Roles y Entidades",
    rolesSubtitle:
      "Tus permisos activos e identidad del sistema dentro del contexto actual.",
    noRoles: "No se encontraron roles para tu usuario.",
    customerId: "ID del cliente: {{id}}",
    entityId: "(Entidad: {{id}})",
    jwtContent: "Contenido del JWT",
    jwtSubtitle: "Datos de sesión y claims sin procesar",
    jwtActiveCustomer: "Claim de Cliente Activo: {{id}}",
    jwtNoActiveCustomer: "No se encontró el claim de cliente activo en el JWT",
    viewAll: "Ver todas las solicitudes",
    noRequests: "No hay solicitudes abiertas",
    goAdmin: "Ir a Administración",
    accessDenied: "Acceso Denegado",
    pleaseSignIn: "Por favor, inicia sesión para ver esta página.",
    goSignIn: "Ir a Iniciar sesión",
    newRequest: "Nueva Solicitud de Reparación",
    newRequestDesc:
      "Reporta una bicicleta dañada o un problema de mantenimiento",
    viewHistory: "Ver Solicitudes",
    viewHistoryDesc: "Sigue el estado de tus solicitudes enviadas",
    quickActions: "Acciones Rápidas",
    recentActivity: "Actividad Reciente",
    myLocations: "Mi Ubicación",
    allLocations: "Todas las Ubicaciones",
    systemDiagnostics: "Diagnósticos del Sistema (Administrador)",
    createRequest: "Nueva solicitud",
    viewDocTypeRequests: "Ver solicitudes",
    orderTracking: "Seguimiento de pedidos",
    orderTrackingDesc: "Entrega de pedidos de material",
    orderTrackingCta: "Ver Seguimiento",
  },
  tracking: {
    title: "Seguimiento de Pedidos",
    subtitle: "Entrega de pedidos de material",
    filterByLocation: "Filtrar por ubicación",
    allLocations: "Todas las ubicaciones",
    columnOrder: "Pedido",
    columnLocation: "Ubicación",
    columnStatus: "Estado",
    columnTrackingLink: "Enlace de seguimiento",
    columnEstDelivery: "Entrega estimada",
    columnNotes: "Notas",
    pendingLogistics: "Pendiente de logística",
    emptyState: "No hay envíos por seguir",
  },
  admin: {
    documentType: {
      title: "Tipos de Documento",
      nameLabel: "Nombre",
      descriptionLabel: "Descripción",
      descriptionPlaceholder: "Describe para qué es este tipo de documento",
      deleteTitle: "Eliminar tipo de documento",
      deleteSuccess: "Tipo de documento eliminado con éxito",
      deleteError: "Error al eliminar el tipo de documento",
      fetchError: "Error al obtener los tipos de documento",
      search: "Buscar tipos de documento...",
    },
    state: {
      title: "Estados",
      search: "Buscar por nombre...",
      empty: "No se encontraron estados",
      nameLabel: "Nombre",
      namePlaceholder: "ej. En Progreso",
      descriptionLabel: "Descripción",
      descriptionPlaceholder: "Describe este estado",
      docTypeLabel: "Tipo de Documento",
      initialLabel: "Estado Inicial",
      finalLabel: "Estado Final",
      initialDescription: "Donde comienza el documento",
      finalDescription: "Donde termina el documento",
      flags: "Etiquetas",
      notifyRolesLabel: "Notificar Roles",
      notifyRolesDescription:
        "Roles a notificar cuando un documento entra en este estado",
      notifyRolesPlaceholder: "Selecciona roles (opcional)",
      translationEnLabel: "Nombre (inglés)",
      translationEsLabel: "Nombre (español)",
      deleteTitle: "Eliminar estado",
      deleteSuccess: "Estado eliminado con éxito",
      deleteError: "Error al eliminar el estado",
      fetchError: "Error al obtener los estados",
      saveError: "Error al guardar el estado",
    },
    transition: {
      title: "Transiciones",
      search: "Buscar transiciones...",
      nameLabel: "Nombre",
      namePlaceholder: "ej. Aprobar",
      fromStateLabel: "Desde Estado",
      fromStatePlaceholder: "Selecciona estado inicial",
      toStateLabel: "Hacia Estado",
      toStatePlaceholder: "Selecciona estado final",
      executorsLabel: "Entidades Ejecutoras",
      executorsPlaceholder: "¿Quién puede ejecutar esto?",
      docTypeLabel: "Tipo de Documento",
      translationEnLabel: "Nombre (inglés)",
      translationEsLabel: "Nombre (español)",
      translationEsPlaceholder: "ej. Aprobar",
      deleteTitle: "Eliminar transición",
      deleteSuccess: "Transición eliminada con éxito",
      deleteError: "Error al eliminar la transición",
      fetchError: "Error al obtener las transiciones",
      saveError: "Error al guardar la transición",
      fetchModalError: "Error al obtener datos del modal",
      visibleFieldsLabel: "Campos Restringidos por Transición",
      visibleFieldsHint:
        "Los campos marcados solo aparecen al ejecutar esta transición. Los campos sin marcar y sin otras restricciones aparecen en todas las transiciones.",
    },
    fieldDefinition: {
      search: "Buscar definiciones de campo...",
      addField: "Agregar Campo",
      editTitle: "Editar: {{label}}",
      nameLabel: "Nombre del Campo (clave técnica)",
      namePlaceholder: "ej. cantidad_kg",
      nameDescription:
        "Solo snake_case. No se puede cambiar después de crearlo.",
      labelLabel: "Etiqueta",
      labelPlaceholder: "ej. Cantidad (kg)",
      typeLabel: "Tipo de Campo",
      sortOrderLabel: "Orden de Visualización",
      requiredLabel: "Obligatorio",
      bikeStatusEffect: "Efecto en Estado de Bicicleta",
      bikeStatusEffectDescription:
        "Al ejecutar esta transición, automáticamente cambia el estado de la bicicleta vinculada. Dejar vacío para sin efecto.",
      bikeStatusNoEffect: "Sin efecto",
      types: {
        text: "Texto",
        textarea: "Área de Texto",
        number: "Número",
        email: "Correo Electrónico",
        date: "Fecha",
        select: "Selector",
        boolean: "Casilla",
        material_picker: "Selector de Materiales",
      },
    },
    entity: {
      title: "Entidades",
      createTitle: "Crear Entidad",
      editTitle: "Editar Entidad",
      nameLabel: "Nombre",
      namePlaceholder: "ej. Juan García",
      typeLabel: "Tipo de Entidad",
      deleteTitle: "Eliminar entidad",
      deleteSuccess: "Entidad eliminada con éxito",
      deleteError: "Error al eliminar la entidad",
      fetchError: "Error al obtener las entidades",
      search: "Buscar entidades",
    },
    role: {
      title: "Roles",
      createTitle: "Crear Rol",
      editTitle: "Editar Rol",
      nameLabel: "Nombre",
      namePlaceholder: "ej. mecanico",
      permissionsLabel: "Acceso por módulo",
      moduleAccessCount_one: "{{count}} módulo",
      moduleAccessCount_other: "{{count}} módulos",
      requestsPermissionsLabel: "Solicitudes — por tipo de documento",
      moduleAccessNoAccess: "Sin acceso",
      moduleAccessRead: "Solo lectura",
      moduleAccessWrite: "Lectura y escritura",
      moduleAccessHasAccess: "Con acceso",
      descriptionLabel: "Descripción",
      descriptionPlaceholder:
        "ej. Gestiona reparaciones de bicicletas y solicitudes de materiales",
      moduleGroups: {
        settings: "Configuración",
        reporting: "Reportes",
        catalog: "Catálogo",
        requests: "Solicitudes",
      },
      customerLabel: "Cliente",
      customerFilterPlaceholder: "Filtrar por cliente",
      search: "Buscar roles...",
      deleteTitle: "Eliminar rol",
      deleteSuccess: "Rol eliminado con éxito",
      deleteError: "Error al eliminar el rol",
      saveError: "Error al guardar el rol",
      createSuccess: "Rol creado con éxito",
      editSuccess: "Rol actualizado con éxito",
      noActiveCustomer: "Sin cliente activo",
      customerPlaceholder: "Elige un customer",
      customerRequired: "Elige el customer al que pertenece este rol",
      noPermissionsTitle: "Sin permisos seleccionados",
      noPermissionsMessage:
        "Este rol no tendrá permisos. ¿Seguro que quieres {{action}} sin permisos?",
      saveAnyway: "Guardar de todos modos",
      goBack: "Volver",
      permissionsLoadError: "Error al cargar los permisos del rol",
      permissions: {
        dashboardRead: "Ver Panel de control",
        dashboardWrite: "Gestionar Panel de control",
        usersRead: "Ver Usuarios",
        usersWrite: "Gestionar Usuarios",
        rolesRead: "Ver Roles",
        rolesWrite: "Gestionar Roles",
        bikesRead: "Ver Bicicletas",
        bikesWrite: "Gestionar Bicicletas",
        bikeCatalogRead: "Ver Catálogo de Bicicletas",
        bikeCatalogWrite: "Gestionar Catálogo de Bicicletas",
        materialsRead: "Ver Materiales",
        materialsWrite: "Gestionar Materiales",
        locationsRead: "Ver Ubicaciones",
        locationsWrite: "Gestionar Ubicaciones",
        stationsRead: "Ver Estaciones",
        stationsWrite: "Gestionar Estaciones",
        devicesRead: "Ver Dispositivos",
        devicesWrite: "Gestionar Dispositivos",
        requestsRead: "Ver Solicitudes",
        requestsWrite: "Crear y Gestionar Solicitudes",
        fsm: "Configuración FSM",
        documentTypesRead: "Ver Tipos de Documento",
        documentTypesWrite: "Gestionar Tipos de Documento",
        customers: "Gestión de Clientes",
        reportingMaterialsBudget: "Presupuesto de Materiales",
        reportingKpiOpsRead: "Ver KPIs Operacionales",
        reportingKpiOpsWrite: "Gestionar KPIs Operacionales",
        trackingOrderTrackingRead: "Ver Seguimiento de Pedidos",
      },
      permissionDescriptions: {
        dashboardRead: "La pantalla de bienvenida del panel de control",
        dashboardWrite: "La pantalla de bienvenida del panel de control",
        usersRead: "Cuentas de usuario y asignación de roles en un cliente",
        usersWrite: "Cuentas de usuario y asignación de roles en un cliente",
        rolesRead: "Roles del cliente y sus conjuntos de permisos",
        rolesWrite: "Roles del cliente y sus conjuntos de permisos",
        bikesRead: "Instancias de bicicletas y su estado de asignación",
        bikesWrite: "Instancias de bicicletas y su estado de asignación",
        bikeCatalogRead: "Catálogo de modelos de bicicletas",
        bikeCatalogWrite: "Catálogo de modelos de bicicletas",
        materialsRead: "Catálogo de materiales usado en solicitudes",
        materialsWrite: "Catálogo de materiales usado en solicitudes",
        locationsRead: "Ubicaciones dentro de un cliente",
        locationsWrite: "Ubicaciones dentro de un cliente",
        stationsRead: "Estaciones dentro de un cliente",
        stationsWrite: "Estaciones dentro de un cliente",
        devicesRead: "Dispositivos conectados (candados) dentro de un cliente",
        devicesWrite: "Dispositivos conectados (candados) dentro de un cliente",
        requestsRead: "Solicitudes de mantenimiento",
        requestsWrite: "Solicitudes de mantenimiento",
        fsm: "Configuración de flujos de trabajo FSM (estados, transiciones)",
        documentTypesRead: "Configuración de tipos de documento de solicitudes",
        documentTypesWrite:
          "Configuración de tipos de documento de solicitudes",
        customers: "Cuentas y configuración de clientes",
        reportingMaterialsBudget:
          "Seguimiento del presupuesto de materiales por ubicación",
        reportingKpiOpsRead: "KPIs operacionales y métricas de desempeño",
        reportingKpiOpsWrite: "KPIs operacionales y métricas de desempeño",
        trackingOrderTrackingRead:
          "Vista de solo lectura de seguimiento de envíos MAT",
      },
      names: {
        procurement: "Procurement",
      },
    },
    user: {
      title: "Usuarios",
      editTitle: "Editar usuario",
      search: "Buscar por nombre o correo electrónico...",
      emailLabel: "Correo electrónico",
      nameLabel: "Nombre",
      roleLabel: "Rol Principal",
      rolePlaceholder: "Seleccionar rol",
      customerPlaceholder: "Elige un customer",
      rolesLabel: "Roles",
      customerLabel: "Cliente",
      addRole: "Agregar Rol",
      removeRole: "Eliminar rol",
      removeRoleNamed: "Quitar rol {{role}}",
      fetchError: "Error al obtener los usuarios",
      saveSuccess: "Usuario actualizado con éxito",
      saveError: "Error al actualizar el usuario",
      addRoleSuccess: "Rol agregado con éxito",
      addRoleError: "Error al agregar el rol",
      removeRoleSuccess: "Rol eliminado con éxito",
      removeRoleError: "Error al eliminar el rol",
      customersLabel: "Clientes",
      addCustomer: "Agregar Cliente",
      removeCustomer: "Eliminar Cliente",
      removeCustomerSuccess: "Cliente eliminado con éxito",
      removeCustomerError: "Error al eliminar el cliente",
      assignCustomer: "Asignar Cliente",
      assignCustomerSuccess: "Cliente asignado con éxito",
      assignCustomerError: "Error al asignar el cliente",
      syncJwt: "Actualizar permisos",
      syncJwtTooltip:
        "Vuelve a aplicar los roles y permisos de este usuario a su sesión activa.",
      syncJwtSuccess: "JWT sincronizado: {{count}} IDs de entidad",
      syncJwtError: "Error al sincronizar JWT",
      userLocationsLabel: "Ubicaciones Asignadas",
      assignLocation: "Asignar Ubicación",
      removeLocation: "Desasignar Ubicación",
      setUserLocationsSuccess:
        "Ubicaciones de usuario actualizadas correctamente",
      setUserLocationsError: "Error al actualizar las ubicaciones de usuario",
      noCustomersForLocations:
        "El usuario debe estar asignado al menos a un cliente antes de asignar ubicaciones.",
      deactivateConfirm:
        "¿Desactivar a {{name}}? Se eliminará su acceso a este cliente.",
    },

    stations: {
      title: "Gestión de Estaciones",
      createTitle: "Crear Estación",
      editTitle: "Editar Estación",
      nameLabel: "Nombre de la estación",
      nameRequired: "El nombre de la estación es obligatorio",
      locationLabel: "Sede",
      locationRequired: "La sede es obligatoria",
      locationFilter: "Filtrar por sede",
      typeLabel: "Tipo",
      types: {
        geofence: "Geofence",
        analog_code: "Código analógico",
        digital_single_point: "Punto único digital",
      },
      geometryLabel: "Geometría (GeoJSON)",
      geometryDescription:
        "Pega un Polygon o MultiPolygon GeoJSON. Los anillos deben estar cerrados (primera y última posición iguales).",
      geometryErrors: {
        required: "La geometría es obligatoria para una estación geofence",
        invalidJson: "La geometría no es JSON válido",
        invalidGeometry:
          "La geometría no es un Polygon/MultiPolygon GeoJSON válido",
      },
      noGeometry: "Sin geometría",
      empty: "No se encontraron estaciones",
      createSuccess: "Estación creada correctamente",
      updateSuccess: "Estación actualizada correctamente",
      deleteTitle: "Eliminar estación",
      deleteConfirm:
        "¿Eliminar esta estación? Las bicis estacionadas en ella no se ven afectadas.",
      deleteSuccess: "Estación eliminada correctamente",
      deleteFailed: "No se pudo eliminar la estación",
      saveFailed: "No se pudo guardar la estación",
    },
    devices: {
      title: "Gestión de Candados",
      createTitle: "Registrar Candado",
      detailTitle: "Detalle del candado",
      customerLabel: "Cliente",
      providerLabel: "Proveedor",
      deviceTypeLabel: "Tipo de dispositivo",
      providerDeviceIdLabel: "ID de dispositivo del proveedor / MAC",
      providerDeviceIdDescription:
        "El identificador que usa el proveedor para este candado, por ejemplo su dirección MAC.",
      providerDeviceIdRequired:
        "El ID de dispositivo del proveedor es obligatorio",
      fleetLabel: "Flota",
      fleetDescription:
        "A qué cuenta del proveedor responde este candado. Determina si los comandos remotos pueden alcanzarlo, y es independiente del customer: un candado guardado en inventario sigue perteneciendo a la flota para la que se compró.",
      fleetRequired: "Elige la flota a la que pertenece este candado",
      fleetColumn: "Flota",
      lockTypeLabel: "Tipo de candado",
      capabilitiesLabel: "Capabilities",
      capabilitiesDescription:
        "Se declaran explícitamente en Fase 1 — el editor de estado manual solo ofrece los campos que estas habilitan.",
      noCapabilities: "Sin capabilities declaradas",
      bikeLabel: "Bici",
      bikeDescription: "Deja vacío para registrar el candado en inventario.",
      bikeRequired: "Selecciona una bici para asociar",
      inventory: "Inventario (sin bici)",
      inventoryFilter: "Solo inventario",
      empty: "No se encontraron candados",
      registerSuccess: "Candado registrado correctamente",
      saveFailed: "No se pudo guardar el candado",
      associateAction: "Asociar",
      associateTitle: "Asociar candado a una bici",
      associateSuccess: "Candado asociado correctamente",
      associateFailed: "No se pudo asociar el candado",
      alreadyAssociatedError: "Esta bici ya tiene un candado asociado.",
      disassociateAction: "Desasociar",
      stateTitle: "Estado manual",
      lockStateLabel: "Estado del candado",
      lockStateDescription:
        "Los estados transitorios solo se ofrecen si el candado declara lock_state_transitional.",
      connectivityLabel: "Conectividad",
      batteryPercentLabel: "Batería (%)",
      batteryVoltageLabel: "Batería (V)",
      ebikeBatteryLabel: "Batería de la e-bike (%)",
      latitudeLabel: "Latitud",
      longitudeLabel: "Longitud",
      accuracyLabel: "Precisión de ubicación (m)",
      tamperLabel: "Sabotaje detectado",
      movementLabel: "Movimiento detectado",
      impactLabel: "Impacto detectado",
      firmwareLabel: "Versión de firmware",
      stateSaveSuccess: "Estado guardado correctamente",
      stateSaveFailed: "No se pudo guardar el estado",
    },
    map: {
      title: "Mapa de Candados",
      empty: "No hay candados con coordenadas registradas",
      providerLabel: "ID de proveedor",
      fleetLabel: "Flota",
      batteryLabel: "Batería",
      lockStateLabel: "Estado",
      batteryUnknown: "Desconocida",
      lockStateLocked: "Cerrado",
      lockStateUnlocked: "Abierto",
      lockStateUnknown: "Desconocido",
      lockStateLocking: "Cerrando",
      lockStateUnlocking: "Abriendo",
      lockStateJammed: "Atascado",
      positionAgeLabel: "Antigüedad de la posición",
      noPositionData: "Sin dato de posición",
    },
    locations: {
      title: "Gestión de Ubicaciones",
      create: "Crear Ubicación",
      createTitle: "Crear Ubicación",
      editTitle: "Editar Ubicación",
      name: "Nombre",
      city: "Ciudad",
      address: "Dirección",
      empty: "No se encontraron ubicaciones",
      nameLabel: "Nombre de Ubicación",
      cityLabel: "Ciudad",
      addressLabel: "Dirección",
      postalCodeLabel: "Código Postal",
      countryLabel: "País",
      latLabel: "Latitud",
      lngLabel: "Longitud",
      keyMaxLength: "Máximo 3 caracteres",
      createSuccess: "Ubicación creada con éxito",
      updateSuccess: "Ubicación actualizada con éxito",
      updateFailed: "Error al actualizar la ubicación",
      deleteTitle: "Eliminar Ubicación",
      deleteWarning: "¿Seguro que quieres eliminar esta ubicación?",
      deleteSuccess: "Ubicación eliminada con éxito",
      filterCustomer: "Cliente",
      allCustomers: "Todos los clientes",
      typeLabel: "Tipo de Ubicación",
      types: {
        client: "Cliente",
        depot: "Depósito",
      },
      deleteFailed: "Error al eliminar la ubicación",
      deactivateSuccess: "Ubicación desactivada con éxito",
      deactivateFailed: "Error al desactivar la ubicación",
      docTypesTitle: "Tipos de Documento Permitidos",
      docTypesDescription:
        "Los usuarios asignados a esta ubicación solo verán los tipos de documento seleccionados.",
      docTypesEmpty:
        "No hay tipos de documento configurados para este cliente.",
      repairLink: {
        title: "Enlace de Solicitud de Reparación",
        description:
          "Comparte este enlace con los usuarios de esta ubicación para enviar solicitudes de reparación.",
      },
    },
    bikes: {
      title: "Gestión de Bicicletas",
      exportButton: "Exportar CSV",
      create: "Crear Bicicleta",
      createTitle: "Crear Bicicleta",
      editTitle: "Editar Bicicleta",
      bike: "Bicicleta",
      brand: "Marca",
      model: "Modelo",
      sku: "SKU",
      serialNumber: "Número de Serie",
      beloraBikeId: "ID de Bici Belora",
      clientBaseNumber: "Número de Base Cliente",
      location: "Ubicación",
      status: "Estado",
      purchaseDate: "Fecha de Compra",
      lastRevisionDate: "Última Revisión",
      acquisitionCost: "Coste de Adquisición",
      wheelSize: "Tamaño de Rueda",
      empty: "No se encontraron bicicletas",
      locationLabel: "Ubicación",
      statusLabel: "Estado",
      brandLabel: "Marca",
      modelLabel: "Modelo",
      submodelLabel: "Submodelo",
      skuLabel: "SKU",
      serialNumberLabel: "Número de Serie",
      beloraBikeIdLabel: "ID de Bici Belora",
      clientBaseNumberLabel: "Número de Base Cliente",
      colorLabel: "Color",
      wheelSizeLabel: "Tamaño de Rueda",
      acquisitionCostLabel: "Coste de Adquisición",
      createSuccess: "Bicicleta creada con éxito",
      createFailed: "Error al crear la bicicleta",
      updateSuccess: "Bicicleta actualizada con éxito",
      updateFailed: "Error al actualizar la bicicleta",
      unknownModel: "Modelo desconocido",
      deleteTitle: "Eliminar Bicicleta",
      deleteWarning: "¿Seguro que quieres eliminar esta bicicleta?",
      deleteSuccess: "Bicicleta eliminada con éxito",
      search: "Buscar por ID, serie...",
      filterLocation: "Ubicación",
      allLocations: "Todas las ubicaciones",
      filterStatus: "Estado",
      allStatuses: "Todos los estados",
      statuses: {
        available: "Disponible",
        in_repair: "En Reparación",
        in_transit: "En Tránsito",
        en_garantia: "En Garantía",
        retired: "Retirado",
      },
    },
    bikeModels: {
      title: "Modelos de Bicicleta",
      createTitle: "Crear Modelo",
      editTitle: "Editar Modelo",
      nameLabel: "Nombre del Modelo",
      modelLabel: "Modelo",
      submodelLabel: "Submodelo",
      codeLabel: "Código",
      codePlaceholder: "p.ej. IEB-2026",
      codeFormatError: "Formato inválido: XX-YYYY",
      codeDuplicateError: "Código ya en uso",
      materialsLabel: "Materiales",
      manageMaterials: "Gestionar materiales",
      deleteTitle: "Eliminar Modelo",
      deleteWarning: "¿Estás seguro de que quieres eliminar este modelo?",
      deleteSuccess: "Modelo eliminado correctamente",
      createSuccess: "Modelo creado correctamente",
      updateSuccess: "Modelo actualizado correctamente",
      fetchError: "Error al obtener los modelos",
      empty: "No se encontraron modelos",
    },
    materials: {
      title: "Catálogo de Materiales",
      empty: "No se encontraron materiales",
      createTitle: "Crear Material",
      editTitle: "Editar Material",
      nameLabel: "Nombre",
      categoryLabel: "Categoría",
      clientCostLabel: "Coste Cliente",
      unitLabel: "Unidad",
      skuLabel: "SKU",
      skuTaken: "El SKU {{sku}} ya lo usa «{{name}}»",
      skuTakenDeactivated:
        "El SKU {{sku}} ya lo usa «{{name}}», que está desactivado. Reactívalo o usa otro SKU",
      isConsumableLabel: "Consumible",
      deleteTitle: "Eliminar Material",
      deleteWarning: "¿Estás seguro de que quieres eliminar este material?",
      deleteSuccess: "Material eliminado correctamente",
      createSuccess: "Material creado correctamente",
      updateSuccess: "Material actualizado correctamente",
      materialLines: "Líneas de Material",
      materialLinesEmpty: "No se han añadido líneas de material.",
      selectMaterial: "Selecciona material",
      searchMaterial: "Buscar material...",
      addMaterial: "Agregar {{name}}",
      decreaseMaterial: "Reducir {{name}}",
      increaseMaterial: "Aumentar {{name}}",
      quantity: "Cantidad",
      addLine: "Añadir línea",
      removeLine: "Quitar {{name}}",
      shipped: "Enviado",
      pending: "Pendiente",
      unitCost: "Costo unitario",
      subtotal: "Subtotal",
      totalCost: "Total",
      noPricesConfigured: "No hay precios configurados para estos materiales.",
      stock: "Stock",
      stockEmpty: "Sin stock configurado para esta ubicación.",
      quantityOnHand: "Cant. disponible",
      lastUpdated: "Última actualización",
      bikeModelsLabel: "Modelos de Bici",
      viewBikeModels: "Ver modelos de bici compatibles",
      consumables: "Consumibles",
      consumablesDescription: "Aplica a todas las bicis seleccionadas",
      translationsSection: "Traducciones",
      nameEnLabel: "Nombre (EN)",
      nameEsLabel: "Nombre (ES)",
      exportButton: "Exportar CSV",
      importButton: "Importar CSV",
      importTitle: "Importar CSV de materiales",
      importSelectFile: "Seleccionar archivo CSV",
      importPlaceholder: "Haz clic para seleccionar un archivo",
      importAdded: "Añadidos",
      importModified: "Modificados",
      importUnchanged: "Sin cambios",
      importUnchangedDesc: "filas sin cambios",
      importChanges: "Cambios",
      importConfirm: "Confirmar {{count}} cambios",
      importValidationError: "Errores de validación",
      importSuccess: "Importación completada",
      importError: "Error al importar materiales",
      relationsExportButton: "Exportar Relaciones CSV",
      relationsImportButton: "Importar Relaciones CSV",
      relationsImportTitle: "Importar CSV relaciones material-modelo",
      relationsImportSuccess: "Relaciones actualizadas",
      relationsImportError: "Error al importar relaciones",
      diffAdded: "Añadidos",
      diffRemoved: "Eliminados",
      diffUnchanged: "Sin cambios",
      bikeModelCode: "Código modelo",
      bikeModelName: "Nombre modelo",
      strategy: "Estrategia de importación",
      strategyReplace: "Reemplazar",
      strategyMerge: "Fusionar",
      strategyReplaceHint:
        "Reemplaza todas las relaciones de los materiales del CSV",
      strategyMergeHint:
        "Solo agrega relaciones nuevas, conserva las existentes",
      relationsConfirm: "Confirmar cambios",
      cancel: "Cancelar",
      searchPlaceholder: "Buscar por nombre, SKU...",
      categoryPlaceholder: "Todas las categorías",
    },
    stock: {
      qtyLabel: "Cant. disponible",
      saveFor: "Guardar stock de {{name}}",
    },
    entityType: {
      title: "Tipos de Entidad",
      createTitle: "Crear Tipo de Entidad",
      editTitle: "Editar Tipo de Entidad",
      nameLabel: "Nombre",
      namePlaceholder: "ej. Rol",
      descriptionLabel: "Descripción",
      descriptionPlaceholder: "Describe para qué es este tipo de entidad",
      deleteTitle: "Eliminar tipo de entidad",
      deleteSuccess: "Tipo de entidad eliminado con éxito",
      deleteError: "Error al eliminar el tipo de entidad",
      fetchError: "Error al obtener los tipos de entidad",
      search: "Buscar tipos de entidad...",
    },
    request: {
      title: "Solicitudes",
      referenceNo: "No. de Referencia",
      titleLabel: "Motivo",
      documentType: "Tipo de Solicitud",
      priority: "Prioridad",
      status: "Estado",
      createdBy: "Creado Por",
      createdAt: "Creado",
      lastUpdate: "Última Actualización",
      total: "Total",
      type: "Tipo",
      actionRequired: "Acción Requerida",
      createNew: "Crear Solicitud",
      viewDetails: "Ver Detalles",
      viewRows: "Vista de lista",
      viewTable: "Vista de tabla",
      showFilters: "Mostrar filtros",
      hideFilters: "Ocultar filtros",
      export: "Exportar",
      exportDownload: "Descargar CSV ({{count}} seleccionadas)",
      selectRow: "Seleccionar orden {{reference}}",
      exportColumnCode: "código",
      exportColumnName: "nombre",
      exportColumnTotal: "total",
      exportFailed: "No se pudieron exportar las órdenes seleccionadas",
      low: "Baja",
      medium: "Media",
      high: "Alta",
      critical: "Crítica",
      fetchError: "Error al obtener las solicitudes",
      createSuccess: "Solicitud creada con éxito",
      createError: "Error al crear la solicitud",
      location: "Ubicación",
      bike: "Bici",
      bikes: "Bicis",
      payload: "Carga Útil",
      availableActions: "Acciones Disponibles",
      consumedMaterials: "Materiales Consumidos",
      consumedMaterialsHint:
        "Declara los materiales utilizados durante la reparación fallida.",
      transitionRequiredFieldsHint:
        "La siguiente información es necesaria para completar esta transición:",
      executeTransition: "Ejecutar Transición",
      transitionErrorNamed: 'Error al ejecutar "{{name}}"',
      fieldsRequired:
        "{{count}} campo(s) obligatorio(s) pendiente(s) de completar.",
      executeTransitionConfirm:
        "¿Estás seguro de que quieres ejecutar <1>{{name}}</1>?",
      selectDocumentType: "Selecciona tipo de solicitud",
      selectLocation: "Selecciona ubicación",
      selectBike: "Selecciona bici",
      selectBikes: "Selecciona bicis",
      reassignBike: "Reasignar Bicicleta",
      reassignBikeHint:
        "Selecciona la bicicleta correcta para esta solicitud de reparación.",
      history: "Historial",
      state: "Estado",
      statusFilter: "Estado",
      statusActive: "Activo",
      statusFinished: "Finalizado",
      deactivateConfirm:
        "¿Desactivar esta solicitud? Esta acción es reversible.",
      noDocTypesConfigured:
        "Contacta al administrador para configurar tipos de solicitud.",
      adminEditMaterialLines: "Editar líneas de materiales",
      adminEditFields: "Editar campos",
      shipmentSection: "Envío",
      shipmentSectionHint:
        "Declara cuántas unidades de cada material se envían ahora.",
      shipmentIncrement: "Este envío",
      shipmentAllShipped: "Todas las líneas ya fueron enviadas por completo.",
      shipmentFillAllPending: "Enviar todo lo pendiente",
      adminEditBike: "Bicicleta afectada",
      adminEditRequestDate: "Fecha de solicitud",
      adminEditCreatedBy: "Creado por",
      adminEditCreatedByPlaceholder: "Buscar entidad...",
      adminEditAddLine: "Agregar línea",
      adminEditRemoveLine: "Eliminar línea",
      adminEditShippedHint: "{{count}} unidad(es) ya enviada(s)",
      adminEditShippedQuantity: "Enviado",
      discountPercent: "Descuento (%)",
    },
  },
  settings: {
    fsmWorkflows: {
      dashboard: "Administración FSM",
      dashboardSubtitle:
        "Gestiona la configuración de la Máquina de Estados Finitos para la red Yalana.",
      documentTypes: "Tipos de Documento",
      documentTypesDescription:
        "Define diferentes tipos de documentos como Órdenes de Trabajo, Tickets, etc.",
      states: "Estados",
      statesDescription:
        "Configura los estados posibles para cada tipo de documento.",
      transitions: "Transiciones",
      transitionsDescription:
        "Configura los movimientos posibles entre estados y quién puede ejecutarlos.",
      entities: "Entidades",
      entitiesDescription:
        "Crea y gestiona instancias específicas de entidades (usuarios, roles, etc.).",
      entityTypes: "Tipos de Entidad",
      entityTypesDescription:
        "Gestiona tipos de entidades como Usuarios, Roles o Departamentos.",
      workflowEditor: "Editor de Flujo",
      workflowEditorDescription:
        "Visualiza y analiza el gráfico FSM para cada tipo de documento.",
      workflowEditorInstructions:
        "Doble clic para editar. Arrastra los conectores para conectar/reconectar.",
      addState: "Añadir Estado",
      manageFields: "Campos",
      autoLayout: "Diseño",
      autoLayoutTitle: "Auto-diseño de nodos",
      refreshTitle: "Refrescar desde el servidor",
      noWorkflowData:
        'No hay estados ni transiciones definidos. Haz clic en "Añadir Estado" para comenzar.',
      workflows: "Flujos",
      currentState: "Estado Actual",
      assignedTo: "Asignado A",
      noActions: "Sin acciones",
      authorizedEntities: "Entidades Autorizadas:",
      noRestrictedEntities: "Sin entidades restringidas (Público)",
      adminEditBadge: "Edición Admin",
      adminEditToggleLabel: "Permitir edición admin",
      adminEditToggleTooltip:
        "Al activarlo, los administradores pueden editar este tipo de documento sin migración ni deploy.",
      createState: "Crear Estado",
      editState: "Editar Estado",
      createTransition: "Crear Transición",
      editTransition: "Editar Transición",
      deleteStateConfirm:
        "¿Estás seguro de que quieres eliminar el estado <b>{{name}}</b>?",
      deleteTransitionConfirm:
        "¿Estás seguro de que quieres eliminar la transición <b>{{name}}</b>?",
      fieldDefinitionEmpty:
        "Aún no hay campos definidos. Agrega campos para recopilar datos estructurados con este tipo de documento.",
      metadataLoadError: "Error al cargar los metadatos iniciales",
      workflowLoadError: "Error al cargar los datos del flujo",
      reconnectError: "Error al actualizar la transición al reconectar",
      executeBy: "Por {{name}}",
      transitionSuccess: "Transición ejecutada con éxito",
      transitionError: "Error al ejecutar la transición",
    },
    customers: {
      title: "Gestión de Clientes",
      create: "Crear Cliente",
      createTitle: "Crear Cliente",
      editTitle: "Editar Cliente",
      search: "Buscar por nombre o slug...",
      name: "Nombre",
      slug: "Slug",
      created: "Creado",
      nameLabel: "Nombre del Cliente",
      slugLabel: "Slug",
      invalidSlug:
        "El slug solo puede contener letras minúsculas, números y guiones",
      slugHelp:
        "Identificador para URLs. Usa letras minúsculas, números y guiones.",
      slugHelpEdit:
        "Cambiar el slug afecta todas las URLs existentes de este customer. Asegurate de actualizar cualquier marcador o enlace.",
      noCustomers: "No se encontraron clientes",
      createSuccess: "Cliente creado con éxito",
      createFailed: "Error al crear el cliente",
      updateSuccess: "Cliente actualizado con éxito",
      updateFailed: "Error al actualizar el cliente",
      deleteTitle: "Eliminar Cliente",
      deleteWarning:
        "¿Estás seguro de que quieres eliminar este cliente? Esta acción es permanente y eliminará todos los datos asociados, incluyendo documentos, flujos de trabajo y solicitudes.",
      deleteSuccess: "Cliente eliminado con éxito",
      deleteError: "Error al eliminar el cliente",
      status: "Estado",
      statusOperational: "Operativo",
      statusIncomplete: "Incompleto",
      completenessTitle: "Completitud: {{name}}",
      completenessLoadError: "Error al cargar el estado de completitud",
      completenessFsmInfoTitle: "Flujo FSM (informativo)",
      completenessGoToFix: "Corregir",
    },
  },
  reporting: {
    materialsBudget: {
      title: "Presupuesto de Materiales",
      from: "Desde",
      to: "Hasta",
      noActiveTitle: "Sin período activo",
      noActive: "No hay período de presupuesto activo para hoy.",
      addPeriod: "Agregar Período",
      createSuccess: "Período de presupuesto creado.",
      createError: "Error al crear el período de presupuesto.",
      amount: "Importe (€)",
      history: "Historial ({{count}} períodos)",
      hideHistory: "Ocultar historial",
      status: "Estado",
      superseded: "Reemplazado",
    },
  },
  fsm: {
    documentTypes: {
      workOrder: { label: "Orden de Trabajo" },
      maintenance: { label: "Mantenimiento" },
    },
    states: {
      draft: { label: "Borrador" },
      pending: { label: "Pendiente" },
      inProgress: { label: "En Progreso" },
      completed: { label: "Completado" },
    },
  },
  pagination: {
    summary: "{{from}}–{{to}} de {{total}}",
    rowsPerPage: "Filas por página",
  },
  repair: {
    sections: {
      bike: "1. Seleccionar Bicicleta",
      details: "2. Detalles del Incidente",
      severity: "3. Gravedad",
    },
    form: {
      title: "Reportar una Avería",
      bike: "Seleccionar Bicicleta",
      bikeSearch: "Buscar por número de serie, marca o modelo...",
      motives: "¿Qué necesita reparación?",
      submit: "Enviar Solicitud de Reparación",
      humanVerification: "Verificación humana",
    },
    success: {
      title: "¡Solicitud Recibida!",
      message: "Tu solicitud de reparación ha sido enviada correctamente.",
      referenceLabel: "Número de Referencia",
      newRepair: "Reportar Otro Problema",
    },
    error: {
      duplicate: "Esta bicicleta ya tiene una solicitud de reparación abierta",
      title: "Error al enviar",
    },
    motive: {
      loose_grips: "Puños Flojos",
      hard_gears: "Marchas Duras",
      pedals_out: "Pedales Sueltos",
      flat_tire: "Pinchazo",
      brakes_dont_stop: "Los Frenos No Paran Bien",
      brakes_loud_noise: "Los Frenos Hacen Ruido",
      chain_comes_out: "Se Sale la Cadena",
      loose_saddle: "Sillín Suelto",
      broken_lock: "Candado Roto",
      lost_key: "Llave Perdida",
      other: "Otro",
    },
    field: {
      prohibits_use: "Impide el Uso de la Bicicleta",
      repair_photo: "Foto de la Reparación",
      materials_used: "Materiales Utilizados",
    },
  },
  mat: {
    field: {
      tracking_url: "URL de tracking",
    },
  },
  warranty: {
    field: {
      description: "Descripción del Problema",
      repair_photo: "Foto como Evidencia",
      photoCount_one: "foto",
      photoCount_other: "fotos",
    },
  },
  notifications: {
    title: "Notificaciones",
    empty: "Sin notificaciones nuevas",
    markAllRead: "Marcar todo como leído",
    unread: "{{count}} notificaciones sin leer",
    pushPrompt: {
      title: "Activar Notificaciones",
      description:
        "Permite notificaciones para recibir alertas cuando las solicitudes requieran tu atención.",
      allow: "Permitir Notificaciones",
      dismiss: "Ahora No",
      enable: "Activar Notificaciones",
    },
    preferences: {
      title: "Preferencias de Notificaciones",
      description: "Elige qué notificaciones quieres recibir.",
      "fsm.transition": "Cambios de estado",
      "fsm.created": "Nuevas solicitudes",
      saved: "Preferencias guardadas",
      saveFailed: "Error al guardar preferencias",
    },
  },
  pwa: {
    installPrompt: {
      title: "Agregar a Pantalla de Inicio",
      description:
        "Instala Belora en tu dispositivo para acceso rápido a solicitudes y reparaciones.",
      descriptionIos:
        "Toca el ícono Compartir y luego 'Agregar a inicio' para instalar Belora.",
      descriptionFirefox:
        "Abre el menú (⋮) y toca 'Agregar a pantalla de inicio' para instalar Belora.",
      install: "Instalar",
      dismiss: "Ahora No",
      ok: "Entendido",
    },
  },
  availableBudget: {
    title: "Presupuesto disponible",
    noBudget: "Sin presupuesto definido",
    locationCount_one: "{{count}} ubicación",
    locationCount_other: "{{count}} ubicaciones",
    exceededCount_one: "{{count}} excedida",
    exceededCount_other: "{{count}} excedidas",
    exceeded: "Presupuesto excedido",
    legendUsed: "Usado",
    legendToOrder: "Por pedir",
    legendAvailable: "Disponible",
    barAriaLabel: "Usado {{used}}, por pedir {{toOrder}}, de {{total}}",
  },
  budgetProjection: {
    orderTotal: "Total del pedido",
    availableToday: "Disponible hoy ({{location}})",
    availableIfApproved: "Disponible si se aprueba",
    noBudget: "Sin presupuesto definido",
  },
  budgetDashboard: {
    title: "Presupuesto de Materiales",
    location: "Ubicación",
    budgetTotal: "Presupuesto",
    spent: "Gastado",
    available: "Disponible",
    utilization: "Uso",
    utilizationAriaLabel: "Uso del presupuesto: {{pct}}%",
    totalBudget: "Presupuesto Total",
    totalSpent: "Total Gastado",
    totalAvailable: "Total Disponible",
    noLocations: "No hay ubicaciones asignadas a tu cuenta.",
    noBudget: "Sin presupuesto definido",
    accessDenied: "Acceso denegado. Se requiere rol de procurement.",
  },
  kpis: {
    title: "KPIs de Operaciones",
    subtitle: "Desempeño de flota y actividad por rango de fechas",
    dateFrom: "Desde",
    dateTo: "Hasta",
    filterLocations: "Filtrar por ubicación",
    filterExecutors: "Filtrar por ejecutor",
    allLocations: "Todas las ubicaciones",
    allExecutors: "Todos los ejecutores",
    apply: "Aplicar",
    fleetTotal: "Flota Total",
    active: "Activas",
    inactive: "Inactivas",
    recoveredOperability: "Operatividad Recuperada",
    requestsHandled: "Solicitudes Atendidas",
    inactiveByState: "Inactivas por Estado",
    byLocation: "Por Ubicación",
    byExecutor: "Por Ejecutor",
    noData: "Sin datos para el período seleccionado",
    locationSection: "{{name}} — {{total}} bicicletas",
    accessDenied: "Acceso denegado. Se requiere rol administrador.",
    summary: {
      title: "Resumen de Operaciones",
      customer: "Cliente",
      noData: "No se encontraron clientes",
    },
  },
  modules: {
    admin: {
      dashboard: "Panel de control",
      locations: "Ubicaciones",
      stations: "Estaciones",
      devices: "Dispositivos",
      bikes: "Bicicletas",
      bikeCatalog: "Catálogo de Bicicletas",
      materials: "Materiales",
      users: "Usuarios",
      roles: "Roles",
      fsmWorkflows: "Flujos de Trabajo FSM",
      documentTypes: "Tipos de Documento",
    },
    settings: {
      customers: "Clientes",
    },
    reporting: {
      kpiOps: "KPIs Operacionales",
      materialsBudget: "Presupuesto de Materiales",
    },
    requests: "Solicitudes",
    portal: {
      bikes: "Portal — Bicicletas",
    },
    tracking: {
      orderTracking: "Seguimiento de pedidos",
    },
  },
} as const;
